/*
Usage:
  <product-flag
    tags="{{ product.tags | join: ',' }}" 
    price="{{ product.price }}" 
    compare_at_price="{{ product.compare_at_price }}"
    available="{{ product.available }}"
  ></product-flag>
*/

type FlagSetting = {
  tag: string;
  display_text: string;
  background_colour: string;
  colour: string;
  available: boolean;
  priority: number;
}

export const ProductFlag = class extends HTMLElement {
  static observedAttributes = ["price", "compare_at_price", "available"];

  tags: string[] = [];
  price = 0;
  compare_at_price: number | null = null;
  flag_settings: FlagSetting[] = []
  available?: boolean;

  connectedCallback() {
    try {
      this.flag_settings = JSON.parse(document.querySelector("[data-product-flags-json]")?.textContent);
    } catch (e) {
      throw "Error parsing product flags JSON";
    }
      
    this.tags = this.getAttribute("tags")?.split(",") || [];
    this.price = parseFloat(this.getAttribute("price") || "");
    this.compare_at_price = parseFloat(this.getAttribute("compare_at_price") || "");
    this.available = this.getAttribute("available") == "true";

    this.displayTag();
  }
  
  attributeChangedCallback(name: string, _oldValue: string, newValue:string) {
    switch (name) {
      case "price": this.price = parseFloat(newValue || ""); break;
      case "compare_at_price": this.compare_at_price = parseFloat(newValue || ""); break;
      case "available": this.available = newValue == "true"; break;
    }
    this.displayTag();
  }

  displayTag() {
    const flag = this.getFlag();
    if (!flag) return this.classList.add("hidden");

    this.className += " uppercase inline-flex";
    this.classList.remove("hidden");
    this.setAttribute("style", `color: ${flag.colour}; background-color: ${flag.background_colour}`);
    this.textContent = flag.display_text;
  }
  
  getFlag() {
    const { price, compare_at_price } = this;
    const tags = [...this.tags];

    // if on sale find the special __sale__ flag
    if (compare_at_price && compare_at_price > price && !tags.includes("label-outlet")) {
      tags.push("__sale__");
    }

    // if no stock find the special __notify__ flag
    // if (!this.available) {
    //   tags.push("__notify__");
    // }
    
    return this.flag_settings
      .filter(flag => tags.includes(flag.tag)) // find applicable tags
      .sort((a, b) => a.priority - b.priority) // sort by priority
      ?.[0] // return first
  }
};

customElements.define("product-flag", ProductFlag);
